import { render, staticRenderFns } from "./Vote.vue?vue&type=template&id=0be37d6f&scoped=true&"
import script from "./Vote.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Vote.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Vote.vue?vue&type=style&index=0&id=0be37d6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be37d6f",
  null
  
)

export default component.exports